// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  restaurantId: __t.u64().name("restaurant_id"),
  seatUid: __t.string().name("seat_uid"),
  kind: __t.string(),
  tier: __t.u32(),
  slotIndex: __t.i32().name("slot_index"),
  floor: __t.u32(),
  x: __t.f32(),
  z: __t.f32(),
  claimedBy: __t.string().name("claimed_by"),
});
